import { api } from './api';
import { ProposedSchema } from './dataSources';

export interface MatchSignature {
  filenamePattern?: string;
  headerCells?: string[];
  sheetNames?: string[];
  columnCount?: number;
}

export interface ImportMapping {
  id: string;
  workspace_id: string;
  name: string;
  schema: ProposedSchema;
  match_signature: MatchSignature;
  auto_run_allocations: boolean;
  use_count: number;
  last_used_at: string | null;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface SaveMappingInput {
  name: string;
  schema: ProposedSchema;
  matchSignature?: MatchSignature;
  autoRunAllocations?: boolean;
}

export const importMappingsApi = {
  list: async (wsId: string): Promise<ImportMapping[]> =>
    (await api.get(`/api/workspaces/${wsId}/import-mappings`)).data,
  get: async (wsId: string, id: string): Promise<ImportMapping> =>
    (await api.get(`/api/workspaces/${wsId}/import-mappings/${id}`)).data,
  create: async (wsId: string, body: SaveMappingInput): Promise<ImportMapping> =>
    (await api.post(`/api/workspaces/${wsId}/import-mappings`, body)).data,
  update: async (wsId: string, id: string, body: Partial<SaveMappingInput>): Promise<ImportMapping> =>
    (await api.patch(`/api/workspaces/${wsId}/import-mappings/${id}`, body)).data,
  remove: async (wsId: string, id: string): Promise<void> => { await api.delete(`/api/workspaces/${wsId}/import-mappings/${id}`); },
  match: async (wsId: string, signature: MatchSignature): Promise<{ mapping: ImportMapping; score: number } | null> =>
    (await api.post(`/api/workspaces/${wsId}/import-mappings/match`, { signature })).data,
};

/** Build a match signature from the upload preview already in hand (no extra round-trip). */
export function signatureFromPreview(
  fileName: string,
  sheets: { name: string; columnCount: number; rows: string[][] }[],
): MatchSignature {
  const first = sheets[0];
  return {
    filenamePattern: fileName,
    headerCells: (first?.rows?.[0] ?? []).map((c) => String(c)).filter(Boolean).slice(0, 40),
    sheetNames: sheets.map((s) => s.name),
    columnCount: first?.columnCount,
  };
}
